<template>
  <BaseExportContact
    postFixer="fireMarshal"
    :inputRequireHighlight="inputRequireHighlight"
    :maxBuildingsPerExport="maxBuildingsPerExport"
    :selectedBuildings.sync="selectedBuildings"
  />
</template>

<script>
import { computed, ref, unref } from 'vue-demi'
import BaseExportContact from '@/pages/ccd/BaseExportContact'
import { aclHelper, ccdPermsTypes } from '@/utils/aclHelper'
import { exportFireMarshal } from '@/api/ccdcontacts/request'

export default {
  components: {
    BaseExportContact,
  },
  setup () {
    const validate = () => {
      if (unref(selectedBuildings).length === 0) {
        inputRequireHighlight.value = true
        return false
      }
      inputRequireHighlight.value = false
      return true
    }
    const exportData = async () => {
      if (!validate()) return
      return exportFireMarshal({
        buildingIds: unref(selectedBuildings).map(b => b.id),
      })
    }
    const exportBtn = computed(() => {
      const hasAccess = aclHelper.getAccess(ccdPermsTypes.exportContact.exportFireMarshal)
      return hasAccess ? {
        actionTitle: 'export',
        func: exportData,
      } : {}
    })
    const selectedBuildings = ref([])
    const inputRequireHighlight = ref(false)
    const maxBuildingsPerExport = ref(5)
    return {
      selectedBuildings,
      inputRequireHighlight,
      maxBuildingsPerExport,
      exportBtn,
    }
  },
}
</script>
